import { Container, Text, TextStyle } from "pixi.js";

export interface UIConfig {
  screenWidth: number;
  screenHeight: number;
}

export class UIManager extends Container {
  private config: UIConfig;
  private winText: Text;
  private moveCount: number = 0;
  private elapsedSeconds: number = 0;
  private timerInterval: number | null = null;
  private isRunning: boolean = false;
  private movesElement: HTMLElement | null = null;
  private timeElement: HTMLElement | null = null;
  private newGameButtonElement: HTMLElement | null = null;

  constructor(config: UIConfig) {
    super();
    this.name = "UIManager";
    this.config = config;

    // Get HTML elements
    this.movesElement = document.getElementById("moves-counter");
    this.timeElement = document.getElementById("time-counter");
    this.newGameButtonElement = document.getElementById("new-game-btn");

    this.winText = this.createWinText();
    this.winText.name = "WinText";
    this.addChild(this.winText);
  }

  private createWinText(): Text {
    const text = new Text({
      text: "",
      style: new TextStyle({
        fontFamily: "Arial",
        fontSize: 36,
        fill: 0xffd700,
        fontWeight: "bold",
      }),
    });
    text.x = this.config.screenWidth / 2;
    text.y = this.config.screenHeight / 2;
    text.anchor.set(0.5, 0.5);
    return text;
  }

  setNewGameHandler(handler: () => void): void {
    if (this.newGameButtonElement) {
      this.newGameButtonElement.onclick = handler;
    }
  }

  incrementMoves(): void {
    this.moveCount++;
    this.updateMovesDisplay();
  }

  resetMoves(): void {
    this.moveCount = 0;
    this.updateMovesDisplay();
  }

  startTimer(): void {
    this.stopTimer();
    this.elapsedSeconds = 0;
    this.isRunning = true;
    this.updateTimeDisplay();
    
    // Update timer every second
    this.timerInterval = window.setInterval(() => {
      if (this.isRunning) {
        this.elapsedSeconds++;
        this.updateTimeDisplay();
      }
    }, 1000);
  }

  stopTimer(): void {
    this.isRunning = false;
    if (this.timerInterval !== null) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  resetTimer(): void {
    this.stopTimer();
    this.elapsedSeconds = 0;
    this.updateTimeDisplay();
  }

  private updateTimeDisplay(): void {
    const minutes = Math.floor(this.elapsedSeconds / 60);
    const seconds = this.elapsedSeconds % 60;
    const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    if (this.timeElement) {
      this.timeElement.textContent = `Time: ${formattedTime}`;
    }
  }

  getElapsedTime(): number {
    return this.elapsedSeconds;
  }

  private updateMovesDisplay(): void {
    if (this.movesElement) {
      this.movesElement.textContent = `Moves: ${this.moveCount}`;
    }
  }

  showWinMessage(): void {
    this.winText.text = "YOU WIN!";
  }

  hideWinMessage(): void {
    this.winText.text = "";
  }

  getMoveCount(): number {
    return this.moveCount;
  }
}

